import { useCallback, useEffect, useState } from 'react'

export const usePeerService = (peerService: any) => {
  const [peers, setPeers] = useState<any[]>([])
  const [bots, setBots] = useState<any[]>([])
  // Distinguish "discovery in flight" from "discovery done, list is empty" so
  // callers don't flash an empty-state CTA before the first result arrives.
  const [loaded, setLoaded] = useState(false)

  const refresh = useCallback(
    async (opts?: any) => {
      if (!peerService) return
      try {
        const result = await peerService.discover(opts)
        setPeers(result.peers)
        setBots(result.bots)
      } finally {
        setLoaded(true)
      }
    },
    [peerService],
  )

  useEffect(() => {
    if (!peerService) return
    refresh()
    const interval = setInterval(() => refresh(), 30000)
    return () => clearInterval(interval)
  }, [peerService, refresh])

  return { peers, bots, loaded, refresh }
}
